import { ManagedUserProfileTabs } from '@/components/Users';
import { useManagedUserDashboardFeature } from '@/features/managed-user-dashboard/useManagedUserDashboardFeature';

interface Props {
  managerId: string;
  managedUserId?: string | null;
  onReturnToDashboard?: () => void;
}

/**
 * ManagedUserDashboard component.
 *
 * Used for displaying detailed information about a specific managed user.
 */
export const ManagedUserDashboard: React.FC<Props> = ({
  managerId,
  managedUserId,
  onReturnToDashboard,
  ...props
}) => {
  const { managerActiveUser, sessionId } = useManagedUserDashboardFeature({
    managerId,
    managedUserId,
  });

  return (
    <ManagedUserProfileTabs
      managedUser={managerActiveUser}
      managedUserId={managedUserId}
      onReturnToDashboard={onReturnToDashboard}
      sessionId={sessionId}
      {...props}
    />
  );
};

ManagedUserDashboard.displayName = 'ManagedUserDashboard';

export default ManagedUserDashboard;
